/**
  Service to interact with identity
 */
import { AuthState } from '@okta/okta-auth-js'

export class IdentityService {

  constructor(
    private auth: AuthState | null,
    private host: string,
  ) { }

  public sendEmailVerification: (email: string) => Promise<string> =
    async (email: string): Promise<string> => {
      const accessToken = this.auth?.accessToken?.accessToken
      if (!accessToken) throw new Error(IDENTITY_ERROR_AUTH_TOKEN)

      const response: Response = await fetch(`${this.host}/api/v1/verification/emails`, {
        method: 'POST',
        credentials: 'include', // pass jwt
        mode: 'cors',
        headers: new Headers({
          'Authorization': `Bearer ${accessToken}`,
          'Content-Type': 'application/json; charset=utf-8',
        }),
        body: JSON.stringify(
          {
            "email": email,
            "source": "TICKETING"
          })
      });

      if (response.ok) {
        return "ok";
      } else if (response.status === 400) {
        throw new Error(IDENTITY_ERROR_INVALID_EMAIL);
      } else if (response.status === 401) {
        throw new Error(IDENTITY_ERROR_INVALID_TOKEN);
      } else if (response.status === 409) {
        throw new Error(IDENTITY_ERROR_ALREADY_VERIFIED);
      } else {
        console.error('Failed to verify email.  HttpCode:' + response.status);
        throw new Error(IDENTITY_ERROR_ALREADY_VERIFIED);
      }

    };

}

export const IDENTITY_ERROR_INVALID_EMAIL: string = "InvalidEmail";
export const IDENTITY_ERROR_INVALID_TOKEN: string = "InvalidToken";
export const IDENTITY_ERROR_ALREADY_VERIFIED: string = "alreadyVerified";
export const IDENTITY_ERROR_GENERIC: string = "VerifyEmailError";
const IDENTITY_ERROR_AUTH_TOKEN = "NoAuthToken";
